import * as Types from '../../../util/graphql/api.graphql';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';

export const GetUserProfileDocument = gql`
  query GetUserProfile($id: ID!) {
    user(userId: $id) {
      userId
      profile {
        displayName
        email
      }
    }
  }
`;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserProfileQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetUserProfileQueryResponse,
    GetUserProfileQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    GetUserProfileQueryResponse,
    GetUserProfileQueryVariables
  >(GetUserProfileDocument, baseOptions);
}
export function useGetUserProfileLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetUserProfileQueryResponse,
    GetUserProfileQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    GetUserProfileQueryResponse,
    GetUserProfileQueryVariables
  >(GetUserProfileDocument, baseOptions);
}
export type GetUserProfileQueryHookResult = ReturnType<
  typeof useGetUserProfileQuery
>;
export type GetUserProfileLazyQueryHookResult = ReturnType<
  typeof useGetUserProfileLazyQuery
>;
export type GetUserProfileQueryResult = ApolloReactCommon.QueryResult<
  GetUserProfileQueryResponse,
  GetUserProfileQueryVariables
>;
export type GetUserProfileQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type GetUserProfileQueryResponse = {
  __typename: 'Query';
  user?: Types.Maybe<{
    __typename: 'User';
    userId: string;
    profile: {
      __typename: 'UserProfile';
      displayName: string;
      email?: Types.Maybe<string>;
    };
  }>;
};
